<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    
    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
      
        <a-form-model-item
            prop="formCode"
          label="表单CODE">
          <a-input placeholder="请输入表单CODE" v-model="model.formCode" />
        </a-form-model-item>
        <a-form-model-item
            prop="materialCode"
          label="成本项目">
          <a-input placeholder="请输入成本项目" v-model="model.materialCode" />
        </a-form-model-item>
<!--        <a-form-model-item-->
<!--          help="表单数量与耗材数量的关联是：多少个表单占用一个耗材。或者一个表单占用多少耗材。只能值整数。"-->
<!--            prop="formNum"-->
<!--          label="表单数量">-->
<!--          <a-input-number v-model="model.formNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入表单数量" />-->
<!--        </a-form-model-item>-->
<!--        <a-form-model-item-->
<!--          help="表单数量与耗材数量的关联是：多少个表单占用一个耗材。或者一个表单占用多少耗材。只能值整数。"-->
<!--            prop="materialNum"-->
<!--          label="耗材数量">-->
<!--          <a-input-number v-model="model.materialNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入耗材数量" />-->
<!--        </a-form-model-item>-->
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@api/manage'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "TempConfigCostItemModal",
    props:{
      categoryCode:{
        type:String,
        default:''
      }
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          formCode:[baseRules.required],
          materialCode:[baseRules.required],
          formNum:[baseRules.required],
          materialNum:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/tempconfig/tempConfigCostItem/add",
          edit: "/tempconfig/tempConfigCostItem/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign({categoryCode: this.categoryCode},this.model);

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>